export const researchCoordinator = '2287d19c-ed32-401b-95ef-09aad120c200'
export const slide1 = '04371f30-f2cd-4126-de4d-e965d08ebe00'
export const slide2 = '234fe127-a825-43ce-d71f-8256badd0500'
export const slide3 = '2dda1c19-83e8-4dd7-5920-c82634bfc400'
export const hero = 'e20bb3d2-72ce-4897-4f4f-7b0f99e95900'
export const trialCards = 'adfc4de8-9b1a-4d84-5793-1d9ea3681100'
export const patientTable = 'd462de24-90c8-4d8a-21c4-73b68582ec00'
export const preScreener = 'f201a83c-6689-4e16-62f4-d58af2d4e800'

// patient cards profile pic
export const Devon = 'e11d451e-ff0f-4238-ab10-85dfdd0ed400'
export const Jorge = '8ed34a8d-2463-485a-1105-dbbfab915f00'
export const Bethany = '58ed1d9f-02a4-413a-a34e-b8f57be6ff00'
export const Charlie = 'f1500b9e-2f08-422a-9a2a-2984d618f200'
export const Tanisha = 'c891a4a1-6b72-4364-7ca7-2b355f2eb700'
export const Dan = '29affe9f-86b0-4860-ae49-66d70ec23700'
export const Lucia = 'eac9757e-c38e-4bbc-a70f-5227ea8cef00'
export const Lin = '28d15007-0839-4d3a-eeca-377ab5c55f00'
